import React from 'react';
import Highlighter from 'react-highlight-words';
import { Link } from 'react-router-dom';
import { Product } from '../../types/product';
import ProductIcon from './ProductIcon';

interface Props {
  product: Product;
  search?: string;
}

const ProductCard = ({ product, search }: Props) => {

  return (
    <Link to={`/solutions/product/${product.id}`} key={product.id} className=''>
      <div
        key={product.id}
        className='cursor-pointer p-4 rounded-xl border border-gray-20 h-full flex flex-col items-center text-center bg-gray-10 transition-colors duration-500 hover:bg-gray-15 hover:border-gray-30'
      >
        <ProductIcon svgIconId={product.svg_icon} />
        <h4 className='my-1 leading-5'>
          <Highlighter
            highlightClassName='font-semibold p-px -m-px rounded-sm bg-warning-lighter'
            searchWords={[search]}
            autoEscape={true}
            textToHighlight={product?.name ?? ''}
          />
        </h4>
        {!!product.architecture?.length && (
          <div className='flex gap-1 my-1 flex-wrap justify-center w-full'>
            {product.architecture?.map((arch, n) => (
              <div
                key={arch.id}
                className='bg-gray-20 py-px whitespace-nowrap leading-5 px-3 rounded-xl border border-gray-30 text-xs'
              >
                {arch.name}
              </div>
            ))}
          </div>
        )}
        <p className='text-sm leading-4 my-1'>
          {product?.description ?? ''}
        </p>
      </div>
    </Link>
  );
};

export default ProductCard;
